import axios from 'axios';

const state = {
  reservedSerials: [], // Holds the list of serial numbers reserved for the current batch
  maxSerialId: 49999, // Initial value is one less than the starting serial number (50000)
};

const mutations = {
  SET_RESERVED_SERIALS(state, serials) {
    state.reservedSerials = serials;
  },
  SET_MAX_SERIAL_ID(state, maxId) {
    state.maxSerialId = maxId;
  },
};

const actions = {
  /**
   * Fetches the highest existing serial number from the database.
   * This should be called on component mount.
   */
  async fetchMaxSerialId({ commit }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
        // If not logged in, we use the default starting value.
        commit('SET_MAX_SERIAL_ID', 49999); 
        return;
    }
    
    try {
      const baseUrl = 'https://api.datafangst.dk/api' || 'http://localhost:3000/api';
      
      const response = await axios.get(`${baseUrl}/serials/max-id`, {
        headers: { Authorization: `Bearer ${userToken}` },
      });
      
      const maxId = response.data.max_id;
      
      // The API returns the MAX ID used (e.g., 50000) or 49999 if the table is empty.
      commit('SET_MAX_SERIAL_ID', maxId);

    } catch (error) {
      console.error('Error fetching max serial ID:', error);
      // Fallback to default start if the network fails
      commit('SET_MAX_SERIAL_ID', 49999);
    }
  },

  /**
   * Reserves a sequence of unique serial numbers from the backend for RFID printing.
   * * NOTE: The backend logic has been updated to rely solely on AUTO_INCREMENT,
   * so the client doesn't need to pass the current max ID.
   */
  async reserveSerials({ commit }, { fullEan, quantity }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      throw new Error('User not authenticated.');
    }

    try {
      const baseUrl = 'https://api.datafangst.dk/api' || 'http://localhost:3000/api';
      
      const response = await axios.post(`${baseUrl}/serials/reserve`, {
        fullEan: fullEan,
        quantity: quantity
      }, {
        headers: { Authorization: `Bearer ${userToken}` },
      });
      
      const serials = response.data.serials;
      
      // OPTIONAL: Update maxSerialId locally after successful reservation (to be safe)
      if (serials.length > 0) {
          const lastSerial = parseInt(serials[serials.length - 1], 10);
          commit('SET_MAX_SERIAL_ID', lastSerial);
      }
      
      commit('SET_RESERVED_SERIALS', serials);
      return serials;

    } catch (error) {
      console.error('Error reserving serials:', error);
      if (axios.isAxiosError(error) && error.response) {
          throw new Error(error.response.data.message || `API Error (${error.response.status})`);
      }
      throw new Error("Network Error: Could not connect to serial reservation service.");
    }
  },
};

const getters = {
  getReservedSerials: (state) => state.reservedSerials,
  getMaxSerialId: (state) => state.maxSerialId,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};